import React, { useEffect, useMemo } from "react";
import { Badge } from "react-bootstrap";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useBarracksUIContext } from "../BarracksContext";
import { Assets } from "../../../constants/assets";
import { useAppTranslation } from "../../../i18n/useAppTranslation";

const BarracksTabs = () => {
  const navigate = useNavigate();
  const { t } = useAppTranslation(["barracks"]);

  const [searchParams] = useSearchParams();

  const barracksContext = useBarracksUIContext();
  const barracksUIProps = useMemo(() => {
    return {
      selectedTab: barracksContext?.selectedTab,
      setSelectedTab: barracksContext?.setSelectedTab,
    };
  }, [barracksContext?.selectedTab, barracksContext?.setSelectedTab]);

  function handleChangeType(active?: undefined | "items" | "camp") {
    barracksUIProps?.setSelectedTab?.(active);
    navigate({
      pathname: "/barracks",
      search: active ? "type=" + active : undefined,
    });
  }

  useEffect(() => {
    const id: any = searchParams.get("type");
    if (
      id &&
      id !== barracksUIProps?.selectedTab &&
      (id === "items" || id === "camp")
    ) {
      barracksUIProps?.setSelectedTab?.(id);
    }
  }, [searchParams, barracksUIProps]);

  return (
    <div style={{ maxWidth: "550px" }} className="mx-auto d-flex  gap-1 mt-3 mt-md-0">
      <button
        onClick={() => {
          handleChangeType();
        }}
        className="theme-btn  button m-0 p-0"
      >
        <img
          className="img-fluid"
          src={
            !barracksUIProps?.selectedTab
              ? "/assets/images/buttons/active-tab-btn.png"
              : "/assets/images/buttons/off-tab-btn.png"
          }
          alt=""
        />
        <div className="b-text">
          <span className="text-light fs-big fs-sm-small d-flex align-items-center gap-1 ">
            <img
              className="me-0 me-sm-1"
              width="17px"
              alt=""
              src={Assets.icons.blades}
            />
            {t("barracks:title")}
          </span>
        </div>
      </button>
      <button
        onClick={() => {
          handleChangeType("items");
        }}
        className="theme-btn  button  m-0 p-0"
      >
        <img
          className="img-fluid"
          src={
            barracksUIProps?.selectedTab === "items"
              ? "/assets/images/buttons/active-tab-btn.png"
              : "/assets/images/buttons/off-tab-btn.png"
          }
          alt=""
        />
        <div className="b-text d-flex align-items-center gap-1">
          <img
            className="me-0 me-sm-1"
            src="/assets/images/icons/items.png"
            width="19px"
            height={19}
            alt=""
          />
          <span className="text-light fs-big fs-sm-small">{t("barracks:labels.items")}</span>
        </div>
      </button>
      <button
        onClick={() => {
          handleChangeType("camp");
        }}
        className="theme-btn position-relative  m-0 p-0 button  "
      >
        <img
          className="img-fluid"
          src={
            barracksUIProps?.selectedTab === "camp"
              ? "/assets/images/buttons/active-tab-btn.png"
              : "/assets/images/buttons/off-tab-btn.png"
          }
          alt=""
        />
        <div className="b-text d-flex align-items-center gap-1">
          <img
            className="me-0 me-sm-1"
            src={Assets.icons.barracks}
            width="15px"
            height={15}
            alt=""
          />
          <span className="text-light fs-lg fs-sm-small">{t("barracks:labels.arenaCamp")}</span>
        </div>
      </button>
    </div>
  );
};
export default BarracksTabs;
